import React from 'react'
import { Link } from 'react-router-dom'

import './footer.css'

const Footer = (props) => {
  return (
    <div className="footer-container10">
      <div className="footer-container11">
        <div className="footer-container12">
          <h1 className="footer-text1">Let&apos;s keep in touch</h1>
          <div className="footer-container13">
            <div className="footer-container14">
              <a
                href="https://www.facebook.com/share/1CHjJ68yyA/?mibextid=wwXIfr"
                target="_blank"
                rel="noreferrer noopener"
                className="footer-link1"
              >
                <svg viewBox="0 0 1024 1024" className="footer-icon1">
                  <path d="M928 0h-832c-52.8 0-96 43.2-96 96v832c0 52.8 43.2 96 96 96h416v-448h-128v-128h128v-64c0-105.8 86.2-192 192-192h128v128h-128c-35.2 0-64 28.8-64 64v64h192l-32 128h-160v448h288c52.8 0 96-43.2 96-96v-832c0-52.8-43.2-96-96-96z"></path>
                </svg>
              </a>
            </div>
            <div className="footer-container15">
              <a
                href="https://www.instagram.com/race.consulting?igsh=ZjU1bzB3OG01cnBv&amp;utm_source=qr"
                target="_blank"
                rel="noreferrer noopener"
                className="footer-link2"
              >
                <svg
                  width="256"
                  height="256"
                  viewBox="0 0 256 256"
                  className="footer-icon3"
                >
                  <g fill="currentColor">
                    <path
                      d="M176 32H80a48 48 0 0 0-48 48v96a48 48 0 0 0 48 48h96a48 48 0 0 0 48-48V80a48 48 0 0 0-48-48m-48 136a40 40 0 1 1 40-40a40 40 0 0 1-40 40"
                      opacity=".2"
                    ></path>
                    <path d="M176 24H80a56.06 56.06 0 0 0-56 56v96a56.06 56.06 0 0 0 56 56h96a56.06 56.06 0 0 0 56-56V80a56.06 56.06 0 0 0-56-56m40 152a40 40 0 0 1-40 40H80a40 40 0 0 1-40-40V80a40 40 0 0 1 40-40h96a40 40 0 0 1 40 40Zm-88-96a48 48 0 1 0 48 48a48.05 48.05 0 0 0-48-48m0 80a32 32 0 1 1 32-32a32 32 0 0 1-32 32m64-84a12 12 0 1 1-12-12a12 12 0 0 1 12 12"></path>
                  </g>
                </svg>
              </a>
            </div>
            <a
              href="https://www.linkedin.com/in/melissa-decker-7a6181303?utm_source=share&amp;utm_campaign=share_via&amp;utm_content=profile&amp;utm_medium=ios_app"
              target="_blank"
              rel="noreferrer noopener"
              className="footer-link3"
            >
              <div className="footer-container16">
                <svg
                  width="128"
                  height="128"
                  viewBox="0 0 128 128"
                  className="footer-icon7"
                >
                  <path
                    d="M116 3H12a8.91 8.91 0 0 0-9 8.8v104.42a8.91 8.91 0 0 0 9 8.78h104a8.93 8.93 0 0 0 9-8.81V11.77A8.93 8.93 0 0 0 116 3z"
                    fill="#0076b2"
                  ></path>
                  <path
                    d="M21.06 48.73h18.11V107H21.06zm9.06-29a10.5 10.5 0 1 1-10.5 10.49a10.5 10.5 0 0 1 10.5-10.49m20.41 29h17.36v8h.24c2.42-4.58 8.32-9.41 17.13-9.41C103.6 47.28 107 59.35 107 75v32H88.89V78.65c0-6.75-.12-15.44-9.41-15.44s-10.87 7.36-10.87 15V107H50.53z"
                    fill="#fff"
                  ></path>
                </svg>
              </div>
            </a>
            <div className="footer-container20">
              <a
                href="https://www.youtube.com/@MelissaDecker-n6k"
                target="_blank"
                rel="noreferrer noopener"
                className="footer-link4"
              >
                <svg
                  height="40"
                  width="30"
                  viewBox="0 0 48 48"
                  className="footer-icon19"
                >
                  <defs>
                    <mask id="ipSYoutube0">
                      <g fill="none" strokeLinejoin="round">
                        <path
                          fill="#fff"
                          stroke="#fff"
                          strokeWidth="4"
                          d="M11.064 10.414Q19.378 10 23.998 10t12.939.415a6 6 0 0 1 5.68 5.492q.381 4.55.381 8.017q0 3.508-.39 8.128a6 6 0 0 1-5.587 5.483Q29.91 38 23.998 38q-5.91 0-13.018-.465a6 6 0 0 1-5.587-5.48q-.395-4.655-.395-8.131q0-3.435.385-8.02a6 6 0 0 1 5.68-5.49Z"
                        ></path>
                        <path
                          fill="#000"
                          stroke="#000"
                          strokeWidth="3.429"
                          d="M21 19.61v8.796a.857.857 0 0 0 1.33.715l6.597-4.36a.857.857 0 0 0 .006-1.427l-6.598-4.436a.857.857 0 0 0-1.335.711Z"
                        ></path>
                      </g>
                    </mask>
                  </defs>
                  <path
                    fill="currentColor"
                    d="M0 0h48v48H0z"
                    mask="url(#ipSYoutube0)"
                  ></path>
                </svg>
              </a>
            </div>
          </div>
        </div>
        <div className="footer-container17">
          <div className="footer-container18">
            <span className="footer-text2">LINKS</span>
            <Link to="/" className="footer-navlink1 TextSM">
              Home
            </Link>
            <Link to="/services" className="footer-navlink2">
              Services
            </Link>
            <Link to="/about-us" className="footer-navlink3 TextSM">
              About Us
            </Link>
            <Link to="/contact-us" className="footer-navlink4 TextSM">
              Contact Us
            </Link>
          </div>
        </div>
      </div>
      <div className="footer-container19"></div>
      <span className="footer-text3 TextSM">
        Copyright © 2025 R.A.C.E. Consulting
      </span>
    </div>
  )
}

export default Footer
